export type PromSample = { metric: string; labels: Record<string, string>; value: number };

export async function fetchPromMetrics(baseUrl: string, path = '/metrics'): Promise<PromSample[]> {
  const res = await fetch(new URL(path, baseUrl).toString(), {
    credentials: 'include',
    cache: 'no-store',
  });
  if (!res.ok) throw new Error(`metrics HTTP ${res.status}`);
  const text = await res.text();
  const lines = text.split(/\r?\n/);
  const out: PromSample[] = [];
  for (const line of lines) {
    if (!line || line.startsWith('#')) continue;
    const m = line.match(
      /^(?<name>[a-zA-Z_:][a-zA-Z0-9_:]*)(?<labels>\{[^}]*\})?\s+(?<value>[-+]?\d*\.?\d+(?:[eE][-+]?\d+)?)/,
    );
    if (!m || !m.groups) continue;
    const metric = m.groups.name as string;
    const value = Number(m.groups.value);
    const labelsText = (m.groups.labels as string) || '';
    const labels: Record<string, string> = {};
    if (labelsText) {
      const inner = labelsText.slice(1, -1); // remove { }
      const parts = inner.match(/(?:"[^"]*"|[^,])+/g) || [];
      for (const part of parts) {
        if (!part.trim()) continue;
        const [k, v] = part.split('=');
        const unq = (v || '').replace(/^"|"$/g, '').replace(/\\"/g, '"');
        labels[k.trim()] = unq;
      }
    }
    out.push({ metric, labels, value });
  }
  return out;
}

export function sumBy(
  samples: PromSample[],
  metric: string,
  labelFilter?: Record<string, string>,
): number {
  return samples
    .filter(
      (s) =>
        s.metric === metric &&
        (!labelFilter || Object.entries(labelFilter).every(([k, v]) => s.labels[k] === v)),
    )
    .reduce((acc, s) => acc + (Number.isFinite(s.value) ? s.value : 0), 0);
}
